import { AxiosInstance, AxiosRequestConfig } from "axios"

export interface CreateAgencyUserRequest extends Partial<AxiosRequestConfig> {
  data: {
    firstName: string
    lastName: string
    email: string
    dialerCode: string
    mobile: string
  }
}

export interface CreateAgencyUserResponseData {
  userId: number
  email: string
  role: "OWNER" | "MEMBER"
  taPriceConfigId: number
  agentStatus: string
  message: string
}

export interface CreateAgencyUserResponse {
  time: string
  apiStatus: string
  data: CreateAgencyUserResponseData
}

export function createAgencyUserApi(
  { data, ...config }: CreateAgencyUserRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "post",
    url: "/agent/agency/users",
    data,
    ...config,
  }) as Promise<{ data: CreateAgencyUserResponse }>
}
